/**
 * @file api/proxyRoutes.js
 * @description API functions for the /api/proxy-routes resource.
 */

import apiClient from './client';

/**
 * Fetches all proxy route configurations.
 * @returns {Promise<Array>}
 */
export const listProxyRoutes = async () => {
  const res = await apiClient.get('/api/proxy-routes');
  return res.data;
};

/**
 * Fetches a single proxy route by ID.
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getProxyRoute = async (id) => {
  const res = await apiClient.get(`/api/proxy-routes/${id}`);
  return res.data;
};

/**
 * Creates a new proxy route configuration.
 *
 * @param {{
 *   name: string,
 *   description?: string,
 *   path_prefix: string,
 *   upstream_url: string,
 *   method?: string,
 *   strip_prefix?: boolean,
 *   auth_required?: boolean,
 *   active?: boolean
 * }} payload
 * @returns {Promise<Object>}
 */
export const createProxyRoute = async (payload) => {
  const res = await apiClient.post('/api/proxy-routes', payload);
  return res.data;
};

/**
 * Updates an existing proxy route.
 * @param {number} id
 * @param {Object} payload - Fields to update.
 * @returns {Promise<Object>}
 */
export const updateProxyRoute = async (id, payload) => {
  const res = await apiClient.put(`/api/proxy-routes/${id}`, payload);
  return res.data;
};

/**
 * Permanently deletes a proxy route.
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteProxyRoute = async (id) => {
  const res = await apiClient.delete(`/api/proxy-routes/${id}`);
  return res.data;
};
